import * as tracking from 'dibs-tracking';
import { getPromoCreative } from '../../helpers/getPromoCreative';

function trackEditorialImpressions(items) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) => {
            const url = item?.linkData?.path || '';
            const position = index + 1;
            return {
                id: `content-promo-${position}`,
                name: `Content Promo #${position}`,
                creative: getPromoCreative(url),
                position: position,
            };
        }),
    });
}

function trackEditorialClick(item, index) {
    const url = item?.linkData?.path || '';
    const position = index + 1;
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: `content-promo-${position}`,
                name: `Content Promo #${position}`,
                creative: getPromoCreative(url),
                position: position,
            },
        ],
    });
}

export { trackEditorialImpressions, trackEditorialClick };
